var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.601,
    height: 66.894,
    viewBox: "0 0 68.601 66.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ButtonIcon_Arrow",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1029",
    "data-name": "Tracciato 1029",
    d: "M19.19,0,.666,16.879,0,41.729,9.351,61.408l23.775,5.486,23.13-10.3L68.6,33.472,58.469,5.173,31.125.154Z",
    transform: "translate(0 0)",
    fill: "#826c9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1030",
    "data-name": "Tracciato 1030",
    d: "M35.944,47.4l-4.5-4.673L46.194,33.1,12.749,34.531l-.425-6.064,35.559,1.7L32.757,18.483l4.99-6.6L57.772,31.133Z",
    transform: "translate(-2.184 1.803)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconArrow);
export default __webpack_public_path__ + "static/media/ButtonIcon_Arrow.784b4f14d3679458949dfe0bd544225f.svg";
export { ForwardRef as ReactComponent };